
import request from '@/request'
const part_url = '/';

function code(data) {
  let url = part_url + "code";
  return request.get(url, data)
}


export default {
    code,
  }


// WEBPACK FOOTER //
// ./src/api/code.js